import { Button } from 'components/Button/Button';
import { Dropdown, Placement } from 'components/Dropdown';

import { StyledMenuContainer } from './ListingActionsDropdown.styled';
import { ListingActionsDropdownListingType } from './ListingActionsDropdownTypes';
import { ReportListingMenuItem } from './ReportListingMenuItem';
import { SaveOrgMenuItem } from './SaveOrgMenuItem';
import { ShareMenuItem } from './ShareMenuItem';

function ThreeDots() {
  return (
    <Button icon={{ type: 'normalized', name: '3-dots' }} variant="secondary" />
  );
}

type Props = {
  listing: ListingActionsDropdownListingType;
  mobilePlacement?: Placement;
  placement?: Placement;
};

export function ListingActionsDropdown({
  listing,
  mobilePlacement,
  placement,
}: Props) {
  return (
    <Dropdown
      aria-label={getText('View more actions')}
      data-qa-id="listings-more-actions"
      title={ThreeDots}
      mobilePlacement={mobilePlacement || 'right'}
      placement={placement || 'right'}
      hideCloseTrigger
      noTriggerPadding
      menuContainerComponent={StyledMenuContainer}
      unstyled
      render={({ closeMenu }) => (
        <>
          <ShareMenuItem closeMenu={closeMenu} listing={listing} mobileOnly />
          {listing.type !== 'ORG' &&
          listing.type !== 'GRAD_PROGRAM' &&
          listing.org ? (
            <SaveOrgMenuItem
              closeMenu={closeMenu}
              orgId={listing.org.id}
              orgName={listing.org.name}
              orgType={listing.org.orgType}
            />
          ) : null}
          <ReportListingMenuItem closeMenu={closeMenu} listing={listing} />
        </>
      )}
    />
  );
}
